import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ListingBlock from '@/app/components/listing/ListingBlock.vue'

import type { ListView } from '@/models/docs.list'
import type { ListItem } from '@/models/interfaces'


export default /*@__PURE__*/_defineComponent({
  __name: 'PodcastsBlock',
  props: {
    view: {},
    docViewEventProperties: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListingBlock, {
    class: "podcasts-block",
    view: __props.view,
    docs: __props.view.docs().filteredDocs,
    docViewEventProperties: __props.docViewEventProperties
  }, null, 8, ["view", "docs", "docViewEventProperties"]))
}
}

})